@if (active) {
<!-- Compact, translucent HUD that floats OVER the incoming section so the
     operator can still see the agent open the panel and take actions on the
     page underneath (same visual confirmation as the admin drawer). -->
<div
    class="ka-hud"
    [attr.data-state]="orbState"
    [attr.data-heard]="userSpeaking ? 'true' : null"
>
    <!-- Full-width voice waveform behind the text (GSAP-driven). Animated
         equalizer bars span the whole HUD to invite the operator to talk; they
         speed up while the assistant is speaking. -->
    <div class="ka-eq" aria-hidden="true">
        <span class="ka-eq__bar"></span>
        <span class="ka-eq__bar"></span>
        <span class="ka-eq__bar"></span>
        <span class="ka-eq__bar"></span>
        <span class="ka-eq__bar"></span>
        <span class="ka-eq__bar"></span>
        <span class="ka-eq__bar"></span>
        <span class="ka-eq__bar"></span>
        <span class="ka-eq__bar"></span>
        <span class="ka-eq__bar"></span>
        <span class="ka-eq__bar"></span>
        <span class="ka-eq__bar"></span>
        <span class="ka-eq__bar"></span>
        <span class="ka-eq__bar"></span>
        <span class="ka-eq__bar"></span>
        <span class="ka-eq__bar"></span>
        <span class="ka-eq__bar"></span>
    </div>

    <div class="ka-hud__bar">
        <div class="ka-hud__text">
            @if (isAsleep) {
            <!-- Single big, glowing wake prompt (no redundant second line). -->
            <div class="ka-wake">Say <span class="ka-wake__word">"Yo"</span></div>
            } @else {
            <div class="ka-status" [class]="'ka-status--' + orbState">{{ statusLabel }}</div>
            <!-- What the assistant just said. We never show the user's own transcription. -->
            <div class="ka-caption">{{ assistantLine || 'One moment…' }}</div>

            <!-- TEMP DIAGNOSTIC: live mic level so we can see if the browser is
                 actually picking up the operator's voice. Remove once voice is
                 confirmed working. -->
            <div class="ka-mic-meter" [attr.data-hot]="micLevelPct > 30 ? 'true' : null">
                <div class="ka-mic-meter__fill" [style.width.%]="micLevelPct"></div>
                <span class="ka-mic-meter__val">mic {{ micLevelPct }}%</span>
            </div>
            }
        </div>
    </div>
</div>
}
